const SET_DEVICE_PROFILES = 'app/chirpStackProfiles/SET_DEVICE_PROFILES';
const CLEAN_DEVICE_PROFILES = 'app/chirpStackProfiles/CLEAN_DEVICE_PROFILES';
const SET_CURRENT_PROFILE = 'app/chirpStackProfiles/SET_CURRENT_PROFILE';

const initialState = {
    profilesList: null,
    currentProfile: null,
};

export default function reducer(state = {...initialState}, action) {
    switch (action.type) {
        case SET_DEVICE_PROFILES: {
            return {...state, profilesList: action.payload || []};
        }
        case SET_CURRENT_PROFILE: {
            return {...state, currentProfile: action.payload};
        }
        case CLEAN_DEVICE_PROFILES: {
            return {...state, ...initialState};
        }
        default:
            return state;
    }
}

export const setDeviceProfiles = (payload) => ({
    type: SET_DEVICE_PROFILES,
    payload,
});

export const setCurrentProfile = (payload) => ({
    type: SET_CURRENT_PROFILE,
    payload,
});

export const cleanDeviceProfiles = () => ({
    type: CLEAN_DEVICE_PROFILES,
});
